import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import "./plus.scss";

function ChatPlus(props) {
  const [menuVisible, setMenuVisible] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChangeOption = (option) => {
    if (typeof props.setSelectedOption === "function") {
      props.setSelectedOption(option);
    }
    setMenuVisible(false);
  };

  const getIconForOption = (option) => {
    switch(option) {
      case "Búsqueda":
        return faSearch;
      case "Detalle":
        return faLightbulb;
      default:
        return faPlus;
    }
  }

  return (
    <div className="plus-container" ref={menuRef}>
      <button
        className="plus-btn"
        onClick={() => setMenuVisible(!menuVisible)}
        aria-expanded={menuVisible}
        aria-haspopup="listbox"
        disabled={props.loading || props.loadingProgress}
      >
        <FontAwesomeIcon icon={getIconForOption(props.selectedOption)} />
      </button>

      {menuVisible && (
        <div className="plus-dropdown-menu">
          {props.menuOptions.map((opcion, index) => (
            <div
              key={index}
              className={`plus-menu-item ${props.selectedOption === opcion ? "active" : ""}`}
              onClick={() => handleChangeOption(opcion)}
            >
              <FontAwesomeIcon 
                icon={getIconForOption(opcion)} 
                className="menu-item-icon" 
              />
              <span className="menu-item-text">{opcion}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ChatPlus;

